module.exports = __webpack_public_path__ + "media/images/icons/icn_045-5e1b405cf469dc78a18eb6f7b16dbd6c.svg";